enum StatusReadInquiryFqa {
    NEW = 1,
    NOT_READ = 2,
    READ = 3,
    KEEP = 4,
    ANSWERED = 5
}
export { StatusReadInquiryFqa }
